export default "__VITE_ASSET__BYtHhSTZ__"